import type { ApiResponse, DataType, WithHeaders } from '@oazapfts/runtime';

import type { ExcludeServerErrors } from './exclude-server-errors';

export function handle<R extends WithHeaders<ApiResponse>>(response: R) {
  return {
    async to<O>(handlers: {
      [K in ExcludeServerErrors<R['status']>]: (
        data: DataType<R, K>,
      ) => O | Promise<O>;
    }): Promise<O> {
      // @ts-expect-error - TypeScript struggles with handling response statuses here.
      // We validate the existence of the handler regardless, so this error can be safely ignored.
      const handler = handlers[response.status];

      // 5XX are always exception
      const isServerError = response.status >= 500 && response.status < 600;

      if (!handler || isServerError) {
        throw new NotHandledError(
          response.status,
          response.data,
          response.headers,
        );
      }

      const output = await handler(response.data);

      return output;
    },
  };
}

export class NotHandledError extends Error {
  constructor(
    public status: number,
    public data: unknown,
    public headers: Headers,
  ) {
    super(`HTTP Response status ${status}, not handled`);
  }
}
